/**
 * Blockers — the readiness blockers list rendered above the publish modal's actions.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
/** The readiness blockers (client mirror + any server 409 fieldErrors). Rendered
 *  only when non-empty; otherwise the modal is clean and Confirm is enabled. */
export function Blockers({ messages }: { messages: string[] }) {
  if (messages.length === 0) return null;
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        padding: '10px 12px',
        borderRadius: 8,
        background: 'var(--nb-surface)',
        border: '1px solid var(--nb-border)',
      }}
    >
      <span style={{ fontSize: 11.5, fontWeight: 700, color: '#c0392b' }}>
        Resolve before publishing
      </span>
      <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12.5, color: 'var(--nb-ink)' }}>
        {messages.map((m) => (
          <li key={m}>{m}</li>
        ))}
      </ul>
    </div>
  );
}

/** Visual affordance for a disabled button — `nb-btn` has no `:disabled` rule,
 *  so a disabled button otherwise still reads as clickable. */
